import { render, staticRenderFns } from "./QuickSetting.vue?vue&type=template&id=16af8537&scoped=true"
import script from "./QuickSetting.vue?vue&type=script&lang=js"
export * from "./QuickSetting.vue?vue&type=script&lang=js"
import style0 from "./QuickSetting.vue?vue&type=style&index=0&id=16af8537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af8537",
  null
  
)

export default component.exports